import { HttpEventType } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { throws } from 'assert';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';

@Component({
  selector: 'app-recommandations-form',
  templateUrl: './recommandations-form.component.html',
  styleUrl: './recommandations-form.component.scss',
})
export class RecommandationsFormComponent implements OnInit {
  serviceProviderForm: FormGroup;
  selectedFile: File | null = null;

  selectProduct(prod) {
    this.selectedProduct = prod;
  }
  selectedProduct = null

  isEdit = false; //just to decide what happens when submit is clicked

  public tabs = [{ title: 'Recommend New Service' }, { title: 'Recommend Service' }, ]
  editRecommId = null;
  public products = []

  public isMidShowing = false;

  public uploadProgress = 0;
  public selectedSubRegion = null;

  public set name(value: string) {
    this.serviceProviderForm.controls['name'].setValue(value);
  }
  public set contactDetails(value: string) {
    this.serviceProviderForm.controls['contactDetails'].setValue(value);
  }
  public set company(value: string) {
    this.serviceProviderForm.controls['company'].setValue(value);
  }
  public set usp1(value: string) {
    this.serviceProviderForm.controls['usp1'].setValue(value);
  }
  public set usp2(value: string) {
    this.serviceProviderForm.controls['usp2'].setValue(value);
  }

  onSubRegionClick(val) {
    this.selectedSubRegion = val;
  }
  public selectedCategory = null;

  public categoriesList = [];
  public onCategoryChange(cat) {
    this.selectedCategory = cat;
    console.log(cat, 'selected');
  }

  public _getCategoryList(): void {
    this.commonService.categoryList.subscribe((val: any) => {
      this.categoriesList = val.map((e) => {
        return {
          keyName: e.name,
          sub: e.subCategory.map((i) => ({
            keyName: i.categoryName,
            ...i,
          })),
        };
      });
    });
  }




  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    public roleService: RoleService,
    private commonService: CommonService,
    private customerService: CustomerService
  ) {
    this.serviceProviderForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(100)]],
      contactDetails: ['', [Validators.required, Validators.maxLength(20)]],
      company: ['', [Validators.required, Validators.maxLength(100)]],
      usp1: ['', [Validators.required, Validators.maxLength(100)]],
      usp2: ['', [Validators.maxLength(100)]],
      image: [null],

      iHaveTriedService: [false],
    });
  }

  public subRegionList = []
  ngOnInit(): void {
    this.subRegionList = this.commonService.regionList.map((i) => {
      return {
        keyName: i.name,
        sub: i.subRegions.map((i: any) => {
          return { ...i, keyName: i.name };
        }),
      };
    });
    this._getCategoryList();
    this.getProducts();

  }


  public uspOneFormOneVal = '';
  public uspOneFormOneErr = ''
  public uspTwoFormOneVal = '';
  public submitRecommendByProduct() {
    if (!this.uspOneFormOneVal) {
      this.uspOneFormOneErr = 'This is required';
      this.toastr.info("Unique Selling point is required");
      return;
    }
    if (!this.selectedProduct) {
      this.toastr.info("Please select a service ");
      return;

    }

    const data = {
      unqiqueSellingPointOne: this.uspOneFormOneVal,
      unqiqueSellingPointTwo: this.uspTwoFormOneVal,
      productId: this.selectedProduct?.id
    }
    console.log("sending", data)
    this.auth.recommendProductFromDb(data).subscribe({
      next: () => {
        this.toastr.success("Successfull recommended!");
        this.closeModal()
      },
      error: (err) => {
        console.error(err);
        this.toastr.error("Error something went wrong!")
      }
    })

  }
  public searchString = ''
  getProducts() {
    this.customerService.getMemberShopProductList({ search: this.searchString, limit: 1010 })
      .subscribe({
        next: (data) => {
          //console.log(data)
          this.products = data.body.data
        },
        error: err => {
          console.error(err);
          this.toastr.error("Error loading products")

        }
      })
  }

  get form() {
    return this.serviceProviderForm.controls;
  }
  banner_image_url: string;
  onFileSelect(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.serviceProviderForm.patchValue({ image: this.selectedFile });

      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.banner_image_url = event.target.result;
      };
      reader.readAsDataURL(input.files[0]);
    }
  }


  onSubmit(isByProduct = false) {
    if (this.serviceProviderForm.valid) {
      const formData = new FormData();
      formData.append('nameOfServiceProvider', this.form.name.value);
      formData.append('phone', this.form.contactDetails.value);
      formData.append('company', this.form.company.value);
      formData.append('uniqueSellingPointOne', this.form.usp1.value);
      formData.append('uniqueSellingPointTwo', this.form.usp2.value);
      if (!this.selectedCategory) {
        this.toastr.info('Please select a category for the recommendation');
        return;
      }
      formData.append('categoryId', this.selectedCategory.categorieChildId);

      if (this.selectedFile) {
        formData.append('image', this.selectedFile);
      }
      //console.log(this.form)
      if (!this.form['iHaveTriedService'].value) {
        this.toastr.info(
          'You have to have tried personally to recommend the service'
        );
        return;
      }

      if (
        this.roleService?.roles?.userType.includes('ADMIN') &&
        this.selectedSubRegion
      ) {
        formData.append('subRegionId', this.selectedSubRegion.subRegionId);
      }

      let subs;
      if (this.isEdit) {
        subs = this.auth.editRecommendation(this.editRecommId, formData, {
          reportProgress: true,
          observe: 'events',
        });
      } else {
        subs = this.auth.addRecommendations(formData, {
          reportProgress: true,
          observe: 'events',
        });
      }

      subs.subscribe({
        next: (event) => {
          if (event.type === HttpEventType.UploadProgress) {
            // Update progress percentage
            this.uploadProgress = Math.round(
              (100 * event.loaded) / event.total
            );
          } else if (event.type === HttpEventType.Response) {
            this.toastr.success(
              `${this.isEdit ? 'Edited' : 'Added'} successfully`
            );
            this.closeModal();
            this.uploadProgress = 0;
          }

        },
        error: (err) => {
          console.error(err);
          this.toastr.error(
            `Error while ${this.isEdit ? 'Editting' : 'Adding'
            } recommendation please try again latter`
          );
        },
      });
    } else {
      this.toastr.info("Please make sute all infos are valid")
    }
  }



  closeModal() {
    this.activeModal.dismiss('cancelled');
  }
}
